
// import React, { useState, useEffect } from 'react';
// import { Link } from 'react-router-dom';
// import Button from '@mui/material/Button';
// import { TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Paper } from '@mui/material';
// import { fetchData } from '../../../apiService';

// function SaleDetail({ match }) {
//     const [data, setData] = useState([]);
//     const recordId = match.params.id;

//     useEffect(() => {
//         fetchData('SaleApi', `/SaleDetails/${recordId}`)
//             .then((response) => {
//                 if (response.responseCode === '1111') {
//                     setData(response.response_data);
//                     console.log(response);
//                 }
//             })
//             .catch((error) => {
//                 console.error('Error fetching Sale Details:', error);
//             });
//     }, []);

//     if (!data || data.length === 0) {
//         return <div>Loading...</div>;
//     }

//     const formattedDate = (dateString) => {
//         const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
//         return new Date(dateString).toLocaleDateString(undefined, options);
//     };

//     return (
//         <div className="container mt-6 mx-auto">
//             <div className="mb-2 flex">
//                 <h3 className="psheading flex-grow" style={{ fontFamily: 'Times New Roman', fontSize: '32px' }}>Details</h3>
//                 <Button
//                     variant="contained"
//                     color="error"
//                     component={Link}
//                     to="/SaleIndex"
//                     className="linkcolor"
//                     style={{ marginLeft: '8px' }}
//                 >
//                     BACK TO LIST
//                 </Button>
//             </div>
//             <TableContainer component={Paper}>
//                 <Table>
//                     <TableHead sx={{ backgroundColor: '#f3f3f3' }}>
//                         <TableRow>
//                             <TableCell>Sl.No</TableCell>
//                             <TableCell>Date</TableCell>
//                             <TableCell>Spare</TableCell>
//                             <TableCell>Qty</TableCell>
//                             <TableCell>Rate</TableCell>
//                             <TableCell>PaymentMode</TableCell>
                           
//                         </TableRow>
//                     </TableHead>
//                     <TableBody>
//                         {data.map((item, index) => (
//                             <TableRow key={index}>
//                                 <TableCell>{index + 1}</TableCell>
                                
//                                 <TableCell>{formattedDate(item.invoiceDate)}</TableCell>
//                                 <TableCell>{item.spareparts}</TableCell>
//                                 <TableCell>{item.quantity}</TableCell>
//                                 <TableCell>{item.inAmount}</TableCell>
//                                 <TableCell>{item.isPaymentMethod}</TableCell>
//                             </TableRow>
//                         ))}
//                     </TableBody>
//                 </Table>
//             </TableContainer>
//         </div>
//     );
// }

// export default SaleDetail;




import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import EditIcon from '@mui/icons-material/Edit'; // Import the edit icon
import { TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Paper } from '@mui/material';
import { fetchData } from '../../../apiService';

function SaleDetail({ match }) {
    const [data, setData] = useState([]);
    const recordId = match.params.id;

    useEffect(() => {
        fetchData('SaleApi', `/SaleDetails/${recordId}`)
            .then((response) => {
                if (response.responseCode === '1111') {
                    setData(response.response_data);
                    console.log(response);
                }
            })
            .catch((error) => {
                console.error('Error fetching Sale Details:', error);
            });
    }, []);

    if (!data || data.length === 0) {
        return <div>Loading...</div>;
    }

    const formattedDate = (dateString) => {
        const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
        return new Date(dateString).toLocaleDateString(undefined, options);
    };

    return (
        <div className="container mt-6 mx-auto">
            <div className="mb-2 flex">
                <h3 className="psheading flex-grow" style={{ fontFamily: 'Times New Roman', fontSize: '32px' }}>Details</h3>
                
                {/* <Button
                    variant="contained"
                    color="primary" 
                    component={Link}
                    to="/SaleEdit"
                    className="linkcolor"
                    style={{ marginLeft: '8px' }}
                >
                    <EditIcon /> Edit
                </Button> */}
                <Button
                    variant="contained"
                    color="error"
                    component={Link}
                    to="/SIndex"
                    className="linkcolor"
                    style={{ marginLeft: '8px' }}
                >
                    BACK TO LIST
                </Button>
            </div>
            <TableContainer component={Paper}>
                <Table>
                    <TableHead sx={{ backgroundColor: '#f3f3f3' }}>
                        <TableRow>
                            <TableCell>Sl.No</TableCell>
                            <TableCell>Date</TableCell>
                            <TableCell>Spare</TableCell>
                            <TableCell>Qty</TableCell>
                            <TableCell>Rate</TableCell>
                            {/* <TableCell>PaymentMode</TableCell> */}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {data.map((item, index) => (
                            <TableRow key={index}>
                                <TableCell>{index + 1}</TableCell>
                                <TableCell>{formattedDate(item.invoiceDate)}</TableCell>
                                <TableCell>{item.spareparts}</TableCell>
                                <TableCell>{item.quantity}</TableCell>
                                <TableCell>{item.inAmount}</TableCell>
                                {/* <TableCell>{item.isPaymentMethod}</TableCell> */}
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </div>
    );
}

export default SaleDetail;















